export class PermissionElevationApiError extends Error {
  constructor(
    message: string,
    public statusCode: number,
    public code?: number,
    public errors?: string[],
  ) {
    super(message);
    this.name = 'PermissionElevationApiError';
  }
}

export type FormattedError = {
  message: string;
  details?: string[];
  httpStatus?: number;
  apiCode?: number;
};

function isPermissionElevationApiError(
  error: unknown,
): error is PermissionElevationApiError {
  // Duck-typing check - instanceof fails across module boundaries
  return (
    error instanceof Error &&
    error.name === 'PermissionElevationApiError' &&
    'statusCode' in error
  );
}

export function formatApiError(error: unknown): FormattedError {
  if (isPermissionElevationApiError(error)) {
    const prefix = error.statusCode ? `HTTP ${error.statusCode}: ` : '';
    const suffix = error.code ? ` (Code ${error.code})` : '';
    return {
      message: `${prefix}${error.message}${suffix}`,
      details: error.errors,
      httpStatus: error.statusCode,
      apiCode: error.code,
    };
  }

  if (error instanceof Error) {
    return { message: error.message };
  }

  return { message: String(error) };
}
